<template>
    <div id="HomeDoctor" class="home-box"> 
        <topNav></topNav>
        <div class="cont">
            <el-row > 
                <router-view />
            </el-row>
        </div>
    </div>
</template>

<script>
import topNav from "@/components/traditionalAndWest/topNav.vue"
import left from "@/components/common/left";

export default {
    name: "Home2",
    data() {
        return {

        };
    },
    components: {
        topNav  
    },

     methods:{

    },
    created(){
        if(!this.jumpLogin()) return false
    }
};
</script>

<style>
.home-box {
    background-color: #F3F6FB;
    min-height: 830px; 
}
.cont{
  width: 1100px !important;
  margin: 0 auto;
} 
</style>



// WEBPACK FOOTER //
// src/components/common/homeDoctor.vue